import _find from 'lodash/find';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { formatCurrency } from '../../../utils/currency';
import { isPriceLabel } from '../../../utils/currency/currency';
export function lookupRelatedCatalogObjects(catalogObject, allRelatedObjects) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var relatedObjectsKey = options.relatedObjectsKey;
  var relatedObjectIds = _get(catalogObject, relatedObjectsKey, []);
  if (_isEmpty(relatedObjectIds) || _isEmpty(allRelatedObjects)) {
    return [];
  }
  return relatedObjectIds.map(function (objectId) {
    return _find(allRelatedObjects, function (_ref) {
      var _id = _ref._id;
      return _id === objectId;
    });
  }).filter(Boolean);
}
export function getCategoryItems(category, allItems) {
  return lookupRelatedCatalogObjects(category, allItems, {
    relatedObjectsKey: 'items'
  });
}
export function getItemModifierSets(item, allModifierSets) {
  return lookupRelatedCatalogObjects(item, allModifierSets, {
    relatedObjectsKey: 'modifierSets'
  });
}
export function getModifierSetModifiers(modifierSet, allModifiers) {
  return lookupRelatedCatalogObjects(modifierSet, allModifiers, {
    relatedObjectsKey: 'modifiers'
  });
}
export function getPriceDisplay(price) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$displayZeroCost = _ref2.displayZeroCost,
    displayZeroCost = _ref2$displayZeroCost === void 0 ? false : _ref2$displayZeroCost,
    _ref2$precision = _ref2.precision,
    precision = _ref2$precision === void 0 ? 2 : _ref2$precision;
  if (isPriceLabel(price)) {
    return price;
  }
  var parsedPrice = +price;
  if (parsedPrice === 0 && !displayZeroCost) {
    return '';
  }
  return formatCurrency(parsedPrice, precision);
}